import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import * as fromApp from "../../../store/app.reducer";
import * as selectors from "../../../store/app.selectors";
import * as _ from "lodash";
import { auditTime, distinctUntilChanged } from "rxjs/operators";
import { ModalController, ToastController } from "@ionic/angular";
import * as CartActiveCouponsActions from "./store/cartActiveCoupons.actions";
import { TranslateService } from "@ngx-translate/core";
import * as CompleteOrderValidationActions from "../../../store/complete-order-validation/completeOrderValidation.actions";
import { AnalyticsServiceService } from "src/app/services/analitycsService/analytics-service.service";
import { CouponsScheduleInfoPopupComponent } from "src/app/popups/coupons-schedule-info-popup/coupons-schedule-info-popup.component";
import moment from "moment";
import { isMoment } from "moment-timezone";
import { CartPageAlertsService } from "src/app/services/cartPageAlerts/cart-page-alerts.service";
import * as CartActions from "../../store/cart.actions";
import { Capacitor } from "@capacitor/core";
import {
  buildCouponMinOrderErrorMessage,
  getCouponMinOrderDisplay,
  hasCouponMinOrderRules,
} from "./coupon-min-order.helpers";
import { shouldShowPromoCartCouponsWarning } from "./promo-cart-coupons-warning.helpers";

@Component({
  selector: "app-cart-active-coupons",
  templateUrl: "./cart-active-coupons.component.html",
  styleUrls: ["./cart-active-coupons.component.scss"],
})
export class CartActiveCoupons implements OnInit, OnDestroy {
  public currentUser: any;
  public activeCoupons: any;
  public finalPriceLoading: boolean;
  public couponsSchedule: any;
  public todayIsCouponsExceptionDay: any = null;
  public currentDayName = moment().format("dddd").toLowerCase();
  public currentDayCouponsSchedule: any;
  public couponsExceptionDaysSchedule: any;
  public storeInfo: any;
  public showPromoCartCouponsWarning = false;
  public showCouponsSheduleButton: boolean = false;
  public cartProducts: any;
  public nativePlatform = Capacitor.isNativePlatform();
  public selectedLanguage: any;
  public mo_base: any;
  public couponsMinOrder: any = {};

  private groupApp: any;
  private promoCartNoCouponTimestamp;
  private preorderOnlyNoCouponTimestamp;
  private onlinePaymentOnlyNoCouponTimestamp;
  private lastValidTimestamp: any = null;
  private toastError: any;
  private cartPrices: any;
  private subscriptions: Subscription[] = [];
  private couponsScheduleInfoModal: any;
  private dineIn;
  private orderPickup;

  constructor(
    private store: Store<fromApp.AppState>,
    private toastController: ToastController,
    private translateService: TranslateService,
    private analyticsService: AnalyticsServiceService,
    private modalController: ModalController,
    private cartAlertService: CartPageAlertsService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          let deliveryMethodChanged = false;
          if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
            deliveryMethodChanged = true;
          }
          if (state && !_.isEqual(this.dineIn, state.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
            deliveryMethodChanged = true;
          }
          if (deliveryMethodChanged) {
            this.setCouponsMinOrder();
            this.setPromoCartCouponsWarning();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.selectedLangugage &&
            !_.isEqual(this.selectedLanguage, state.selectedLangugage)
          ) {
            this.selectedLanguage = _.cloneDeep(state.selectedLangugage);
          }

          if (
            state &&
            state.groupApp &&
            !_.isEqual(this.groupApp, state.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);
            this.mo_base = _.cloneDeep(
              _.find(state.groupApp.languages, {
                mo_base: true,
              })
            );

            if (!this.mo_base) {
              this.mo_base = "en";
            } else {
              this.mo_base = this.mo_base.code;
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((storeInfo) => {
          if (storeInfo && !_.isEqual(this.storeInfo, storeInfo)) {
            this.storeInfo = _.cloneDeep(storeInfo);
            this.setPromoCartCouponsWarning();
            this.couponsSchedule = this.formatStoreSchedule(
              this.storeInfo.couponsSchedule
            );
            this.showCouponsSheduleButton = false;
            if (this.couponsSchedule && this.couponsSchedule.length) {
              console.log("coupon schedulecscs", this.couponsSchedule);

              _.each(this.couponsSchedule, (day) => {
                if (day && day.schedule) {
                  this.showCouponsSheduleButton = true;
                }
              });
            }

            if (!_.isEmpty(this.storeInfo.couponsSchedule)) {
              console.log("couponsschedule", this.storeInfo.couponsSchedule);
              this.initializeActions(
                _.cloneDeep(this.storeInfo.couponsSchedule),
                "couponsSchedule"
              );
            }
            if (!_.isEmpty(this.storeInfo.couponsExceptionDays)) {
              this.initializeActions(
                _.cloneDeep(this.storeInfo.couponsExceptionDays),
                "couponsExceptionDays"
              );
            }

            console.log("coupons schedule", this.couponsSchedule);
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && state.user && !_.isEqual(this.currentUser, state.user)) {
            this.currentUser = _.cloneDeep(state.user);
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("disableFinalPrice")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(state.disableFinalPrice, this.finalPriceLoading)
          ) {
            this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartActiveCoupons")
        .pipe(distinctUntilChanged())
        .pipe(auditTime(50))
        .subscribe((state) => {
          if (state && !_.isEqual(this.activeCoupons, state.activeCoupons)) {
            this.activeCoupons = _.cloneDeep(state.activeCoupons);
            this.activeCoupons = _.filter(this.activeCoupons, (coupon) => {
              return (
                !coupon.use_type ||
                (coupon.use_type &&
                  coupon.use_type !== "third_party" &&
                  coupon.use_type !== "instore")
              );
            });
            this.editActiveToDate();
            this.setCouponScheduleLabels();
            this.setCouponsMinOrder();
            this.setPromoCartCouponsWarning();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            state.products &&
            !_.isEqual(this.cartProducts, state.products)
          ) {
            this.cartProducts = _.cloneDeep(state.products);
            this.setPromoCartCouponsWarning();
          }

          if (
            state &&
            state.promoCartNoCouponTimestamp &&
            !_.isEqual(
              this.promoCartNoCouponTimestamp,
              state.promoCartNoCouponTimestamp
            )
          ) {
            this.cartAlertService.closeCantUseCouponsWithPromoCartAlert();
            this.cartAlertService.presentCantUseCouponsWithPromoCartAlert(
              this.storeInfo
            );
            this.store.dispatch(
              new CartActions.SetPromoCartNoCouponTimestamp(null)
            );
          }

          if (
            state &&
            state.preorderOnlyNoCouponTimestamp &&
            !_.isEqual(
              this.preorderOnlyNoCouponTimestamp,
              state.preorderOnlyNoCouponTimestamp
            )
          ) {
            this.cartAlertService.closeCantUseCouponsPreorderOnlyAlert();
            this.cartAlertService.presentCantUseCouponPreorderOnlyAlert(
              this.storeInfo
            );
            this.store.dispatch(
              new CartActions.setPreorderOnlyNoCouponTimestamp(null)
            );
          }

          if (
            state &&
            state.onlinePaymentOnlyNoCouponTimestamp &&
            !_.isEqual(
              this.onlinePaymentOnlyNoCouponTimestamp,
              state.onlinePaymentOnlyNoCouponTimestamp
            )
          ) {
            this.cartAlertService.closeCantUseCouponsOnlinePaymentOnlyAlert();
            this.cartAlertService.presentCantUseCouponOnlinePaymentOnlyAlert();
            this.store.dispatch(
              new CartActions.setOnlinePaymentOnlyNoCouponTimestamp(null)
            );
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartPrices")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            state.cartPrices &&
            !_.isEqual(this.cartPrices, state.cartPrices)
          ) {
            this.cartPrices = _.cloneDeep(state.cartPrices);
          }
        })
    );
    this.subscriptions.push(
      this.store
        .select("completeOrderValidation")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.lastValidTimestamp &&
            !_.isEqual(this.lastValidTimestamp, state.lastValidTimestamp)
          ) {
            this.lastValidTimestamp = _.cloneDeep(state.lastValidTimestamp);
            this.completeOrderCartCoupons();
          }
        })
    );
  }

  editActiveToDate() {
    _.each(this.activeCoupons, (coupon) => {
      if (coupon && coupon.activeTo) {
        coupon.activeTo = moment(
          _.cloneDeep(parseInt(coupon.activeTo.toString()))
        )
          .subtract(1, "day")
          .format("x")
          .toString();
      }
    });
  }

  async openCouponsScheduleInfoModal() {
    this.couponsScheduleInfoModal = await this.modalController.create({
      component: CouponsScheduleInfoPopupComponent,
      cssClass: "CouponsScheduleInfoPopup",
      backdropDismiss: false,
    });
    await this.couponsScheduleInfoModal.present();

    this.couponsScheduleInfoModal.onDidDismiss().then(() => {
      this.couponsScheduleInfoModal = null;
    });
  }

  //TO_DO CHECK TRACK FUNCTION TO RETRUN ITEM ATTR
  trackFunc(index, item) {
    return index;
  }

  async presentErrorToast(message, color, seconds) {
    if (this.toastError) {
      // console.log("toast exist");
      try {
        console.log(this.toastError);
        this.toastError.dismiss();
        this.toastError = null;
      } catch (e) {}
    }
    this.toastError = await this.toastController.create({
      message: message,
      duration: parseInt((seconds ? seconds : 3).toString()) * 1000,
      position: "middle",

      color: color,
      buttons: [
        {
          side: "end",
          icon: "assets/ionicons/close.svg",

          handler: () => {
            console.log("Toast Closed");
          },
        },
      ],
    });

    this.toastError.present();
  }

  calculateDeliveryMethod(pickup, dinein) {
    let deliveryMethod;
    if (pickup && !dinein) {
      deliveryMethod = "takeaway";
    } else if (!pickup && !dinein) {
      deliveryMethod = "delivery";
    } else if (!pickup && dinein) {
      deliveryMethod = "dinein";
    }

    return _.cloneDeep(deliveryMethod);
  }

  private presentErrorToastDebounced = _.debounce((message, color, seconds) => {
    this.presentErrorToast(message, color, seconds);
  }, 300);

  clickCheckboxCoupon(coupon) {
    const deliveryMethod = this.calculateDeliveryMethod(
      this.orderPickup,
      this.dineIn
    );

    var index = _.findIndex(this.activeCoupons, {
      timestamp: coupon.timestamp,
    });
    if (document.activeElement.tagName === "ION-CHECKBOX") {
      if (index !== -1) {
        if (!coupon.validDate) {
          let errorMsg;
          if (coupon.validDateException) {
            if (
              this.storeInfo &&
              this.storeInfo.couponsExceptionsDescription &&
              this.selectedLanguage &&
              this.storeInfo.couponsExceptionsDescription[this.selectedLanguage]
            ) {
              errorMsg = _.cloneDeep(
                this.storeInfo.couponsExceptionsDescription[
                  this.selectedLanguage
                ]
              );
            } else {
              errorMsg = this.translateService.instant(
                "cart.cart-components.cart-active-coupons.today-exceptionally-you-cant-use-the-coupon"
              );
            }
          } else if (coupon.couponScheduleException) {
            // The coupon carries its own usage schedule and this day or hour is
            // outside it. Checked before preorderValidDateException, which the
            // pricing lambda also sets on the same coupon whenever the rule has
            // check_preorder_future_availability: that branch would otherwise
            // win and tell the customer the coupon "is valid from <date>", and
            // it dereferences coupon.activeFrom, which is absent on coupons
            // minted without days_to_expire.
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.coupon-is-not-valid-now"
            );
            if (coupon.couponScheduleLabel) {
              errorMsg =
                errorMsg +
                " " +
                this.translateService.instant(
                  coupon.couponScheduleBlackout
                    ? "cart.cart-components.cart-active-coupons.not-valid-on"
                    : "cart.cart-components.cart-active-coupons.valid-only-on"
                ) +
                ": " +
                coupon.couponScheduleLabel;
            }
          } else if (coupon.preorderValidDateException) {
            errorMsg =
              this.translateService.instant(
                "cart.cart-components.cart-active-coupons.your-coupon-is-valid-from"
              ) +
              " " +
              moment(parseInt(coupon.activeFrom.toString()))
                .format("DD/MM/YYYY")
                .toString() +
              ". " +
              this.translateService.instant(
                "cart.cart-components.cart-active-coupons.your-can-select-preorder-to-use-it"
              );
          } else {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.coupon-is-not-valid-now"
            );
          }
          this.doCheckboxFalseDebounce(index);

          this.presentErrorToastDebounced(errorMsg, "danger", 4);
        } else if (!coupon.validCombo) {
          this.doCheckboxFalseDebounce(index);
          let errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.cannot-be-combined-with-your-other-choices"
          );

          this.presentErrorToastDebounced(errorMsg, "danger", 4);
        } else if (!coupon.validMinOrder && !hasCouponMinOrderRules(coupon)) {
          this.doCheckboxFalseDebounce(index);
          let errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.coupon-requires-a-minimum-order"
          );

          this.presentErrorToastDebounced(errorMsg, "danger", 4);
        } else if (!coupon.validMinOrder) {
          // Per-mode minimum or "discount_items" basis: the message also says
          // the minimum of the current order mode and the categories that count.
          this.doCheckboxFalseDebounce(index);
          let errorMsg = buildCouponMinOrderErrorMessage(
            coupon,
            deliveryMethod,
            (key) => this.translateService.instant(key)
          );

          this.presentErrorToastDebounced(
            errorMsg,
            "danger",
            getCouponMinOrderDisplay(coupon, deliveryMethod).itemNames ? 8 : 4
          );
        } else if (coupon.status === "pending_confirmation") {
          this.doCheckboxFalseDebounce(index);
          let errorMsg = this.translateService.instant(
            "cart.cart-components.cart-active-coupons.coupon-is-pending-confirmation-contact-store"
          );

          this.presentErrorToastDebounced(errorMsg, "danger", 4);
        } else if (
          coupon &&
          coupon.appliesToCategoriesOrProducts &&
          coupon.appliesToCategoriesOrProducts.length &&
          !_.some(this.cartProducts || [], (prd) =>
            _.some(
              coupon.appliesToCategoriesOrProducts,
              (item) =>
                item &&
                (item.type === "category" ||
                  (!item.product_id && !item.sku && !item.product)) &&
                item.id === prd.category_id
            )
          )
        ) {
          const categoryNames = _.chain(coupon.appliesToCategoriesOrProducts)
            .filter(
              (item) =>
                item &&
                item.name &&
                (item.type === "category" ||
                  (!item.product_id && !item.sku && !item.product))
            )
            .map("name")
            .compact()
            .uniq()
            .value();

          if (categoryNames && categoryNames.length) {
            const errorMsg =
              this.translateService.instant(
                "cart.cart-components.cart-active-coupons.the-coupon-is-only-valid-for-categories"
              ) +
              ": " +
              categoryNames.join(", ");

            if (errorMsg) {
              this.presentErrorToastDebounced(errorMsg, "danger", 8);
            }
          }
          this.doCheckboxFalseDebounce(index);
        } else if (
          (coupon.delivery_only &&
            !(
              deliveryMethod === "delivery" ||
              (coupon.dinein_only && deliveryMethod === "dinein") ||
              (coupon.takeaway_only && deliveryMethod === "takeaway")
            )) ||
          (coupon.dinein_only &&
            !(
              deliveryMethod === "dinein" ||
              (coupon.delivery_only && deliveryMethod === "delivery") ||
              (coupon.takeaway_only && deliveryMethod === "takeaway")
            )) ||
          (coupon.takeaway_only &&
            !(
              deliveryMethod === "takeaway" ||
              (coupon.delivery_only && deliveryMethod === "delivery") ||
              (coupon.dinein_only && deliveryMethod === "dinein")
            ))
        ) {
          console.log("Validation failed", deliveryMethod, coupon);

          this.doCheckboxFalseDebounce(index);

          // Determine the appropriate error message
          let errorMsg = "";

          if (
            coupon.delivery_only &&
            coupon.dinein_only &&
            deliveryMethod !== "delivery" &&
            deliveryMethod !== "dinein"
          ) {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-delivery-and-dine-in"
            );
          } else if (
            coupon.delivery_only &&
            coupon.takeaway_only &&
            deliveryMethod !== "delivery" &&
            deliveryMethod !== "takeaway"
          ) {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-delivery-and-takeaway"
            );
          } else if (
            coupon.dinein_only &&
            coupon.takeaway_only &&
            deliveryMethod !== "dinein" &&
            deliveryMethod !== "takeaway"
          ) {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-dine-in-and-takeaway"
            );
          } else if (coupon.delivery_only && deliveryMethod !== "delivery") {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-delivery"
            );
          } else if (coupon.dinein_only && deliveryMethod !== "dinein") {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-dine-in"
            );
          } else if (coupon.takeaway_only && deliveryMethod !== "takeaway") {
            errorMsg = this.translateService.instant(
              "cart.cart-components.cart-active-coupons.is-for-only-takeaway"
            );
          }

          // Show the error message if one is set
          if (errorMsg) {
            this.presentErrorToastDebounced(errorMsg, "danger", 4);
          }
        } else {
          console.log("active coupon", coupon);
          this.analyticsService.dmAnalyticsMessage(
            "selected_coupon",
            null,
            null,
            coupon.description,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          );
          //selected_coupon
          //coupon_description
          this.store.dispatch(
            new CartActiveCouponsActions.SetActiveCoupons(
              _.cloneDeep(this.activeCoupons)
            )
          );
        }
      }
    }
  }

  completeOrderCartCoupons() {
    console.log("complete order cupons");
    let validationObject = {
      id: "active-coupons",
      valid: true,
      errorMessages: [],
      openActiveCouponAlert: false,
    };
    if (
      this.activeCoupons &&
      !_.isEmpty(this.activeCoupons) &&
      !_.find(this.activeCoupons, {
        couponCheckbox: true,
      }) &&
      (_.find(
        this.activeCoupons,
        (coupon) =>
          coupon.validDate &&
          coupon.validCombo &&
          coupon.validMinOrder &&
          !coupon.product_id &&
          this.cartPrices &&
          this.cartPrices.subTotalNoPromos !== 0
      ) ||
        _.find(
          this.activeCoupons,
          (coupon) =>
            coupon.validDate &&
            coupon.validCombo &&
            coupon.validMinOrder &&
            coupon.product_id
        ))
    ) {
      validationObject.openActiveCouponAlert = true;
    }
    this.store.dispatch(
      new CompleteOrderValidationActions.AddUpdateCompleteOrderValidation(
        _.cloneDeep(validationObject)
      )
    );
  }

  calculateBadgeColor(coupon) {
    if (coupon) {
      if (coupon.status === "used") {
        return "used-coupon";
      } else if (coupon.status === "active") {
        return "active-coupon";
      } else if (coupon.status === "expired") {
        return "expired-coupon";
      } else if (coupon.status === "outdated") {
        return "expired-coupon";
      } else if (coupon.status === "canceled") {
        return "used-coupon";
      } else if (coupon.status === "pending_confirmation") {
        return "warning";
        //console.log("set exp coupon");
      }
    }
  }

  doCheckboxFalseDebounce = _.debounce(
    (index) => {
      this.activeCoupons[index].couponCheckbox = false;
    },
    100,
    { maxWait: 200 }
  );

  initializeActions(schedule, type) {
    console.log("initialize actions called", schedule, type);
    if (type === "couponsExceptionDays") {
      _.each(schedule, (item, key) => {
        let day = item.date.split("-");
        let date = moment();
        console.log(
          "valuesss",
          parseInt(day[0]),
          parseInt(day[1]),
          parseInt(day[2])
        );
        date.set("date", parseInt(day[0]));
        date.set("month", parseInt(day[1]) - 1);
        date.set("year", parseInt(day[2]));
        let today = moment();
        console.log("date today", date, today);
        console.log("diff", date.diff(today), key);
        if (date.diff(today) >= 0) {
          item.oldDate = false;
        } else {
          item.oldDate = true;
        }
      });
    }

    console.log("schedule", schedule);

    if (!_.isEmpty(schedule)) {
      let allDaysSchedule = schedule.map((item) => {
        if (!_.isObject(item)) {
          item = {};
        }

        if (!_.isArray(item.time_periods)) {
          item.time_periods = [];
        }
        if (item.date) {
          let day = item.date.split("-");
          // let month = item.date.split("-", 1);
          // let year = item.date.split("-", 2);
          // let date = moment().set({
          //   day: parseInt(day[0]),
          //   month: parseInt(day[1]) - 1,
          //   year: parseInt(day[2]),
          //   hour: 0,
          //   minute: 0,
          //   second: 0,
          // });
          let date = moment();
          date.date(parseInt(day[0]));
          date.month(parseInt(day[1]) - 1);
          date.year(parseInt(day[2]));

          console.log(
            "moment date values",
            parseInt(day[0]),
            parseInt(day[1]),
            parseInt(day[2])
          );
          console.log("moment date object", date);
          item.date = _.cloneDeep(date);
        }
        for (let index = 0; index < item.time_periods.length; index++) {
          if (
            !_.isNumber(item.time_periods[index].stop) ||
            !item.time_periods[index].stop
          ) {
            item.time_periods[index].stop = 1;
          }

          if (
            !_.isNumber(item.time_periods[index].start) ||
            !item.time_periods[index].start
          ) {
            item.time_periods[index].start = 1;
          }

          const start_minutes = +item.time_periods[index].start / 60;
          const start_hours = start_minutes / 60;
          const start_rest_minutes = start_minutes % 60;

          item.time_periods[index].start_timestamp = moment(0)
            .hour(start_hours)
            .minutes(0)
            .add(start_rest_minutes, "minutes")
            .startOf("minute")
            .format();

          const stop_minutes = +item.time_periods[index].stop / 60;
          const stop_hours = stop_minutes / 60;
          const stop_rest_minutes = stop_minutes % 60;

          item.time_periods[index].stop_timestamp = moment(0)
            .hour(stop_hours)
            .minutes(0)
            .add(stop_rest_minutes, "minutes")
            .startOf("minute")
            .format();
        }

        return item;
      });

      if (type === "couponsSchedule") {
        this.currentDayCouponsSchedule = _.cloneDeep(
          allDaysSchedule[moment().weekday()]
        );
      } else if (type === "couponsExceptionDays") {
        this.couponsExceptionDaysSchedule = _.cloneDeep(allDaysSchedule);
        this.checkIfIsExceptionDay(this.couponsExceptionDaysSchedule);
      }
    }

    console.log("type shedule", schedule);
  }

  setCouponScheduleLabels() {
    // The coupon carries its own usage schedule, snapshotted from the rule when
    // it was claimed. Precomputed here rather than called from the template,
    // because formatStoreSchedule resolves seven translations per call and the
    // template would re-run it on every change detection cycle, per coupon.
    _.each(this.activeCoupons, (coupon) => {
      const scheduleLabel = this.buildCouponScheduleLabel(
        coupon && coupon.coupon_schedule
      );
      coupon.couponScheduleLabel = scheduleLabel.text;
      coupon.couponScheduleBlackout = scheduleLabel.blackout;
    });
  }

  setCouponsMinOrder() {
    // The minimum shown next to each coupon depends on the order mode (per-mode
    // minimums) and is precomputed here for the template. Kept apart from the
    // coupon objects because activeCoupons is dispatched to the store and sent
    // to calculate-final-price as is.
    const deliveryMethod = this.calculateDeliveryMethod(
      this.orderPickup,
      this.dineIn
    );
    const couponsMinOrder: any = {};
    _.each(this.activeCoupons, (coupon) => {
      if (coupon && coupon.timestamp) {
        couponsMinOrder[coupon.timestamp] = getCouponMinOrderDisplay(
          coupon,
          deliveryMethod
        );
      }
    });
    this.couponsMinOrder = couponsMinOrder;
  }

  setPromoCartCouponsWarning() {
    // Precomputed for the template; the rule and why it mirrors
    // calculate-final-price are in promo-cart-coupons-warning.helpers. Not
    // recomputed on a click, so the coupon rows stay still until the answer
    // of calculate-final-price reaches the store.
    this.showPromoCartCouponsWarning = shouldShowPromoCartCouponsWarning(
      this.cartProducts,
      this.activeCoupons,
      this.storeInfo,
      this.calculateDeliveryMethod(this.orderPickup, this.dineIn)
    );
  }

  buildCouponScheduleLabel(couponSchedule) {
    // Returns { text, blackout }. blackout flips the wording from
    // "valid only on <days>" to "not valid on <dates>": a rule that is open all
    // week and restricted only by closing exception dates cannot be described
    // positively — listing all seven weekdays reads as "always valid" at the
    // exact moment the coupon is being refused.
    const empty = { text: "", blackout: false };

    if (!couponSchedule || couponSchedule.active !== true) {
      return empty;
    }

    const schedule = _.isArray(couponSchedule.schedule)
      ? couponSchedule.schedule
      : [];
    const exceptions = _.isArray(couponSchedule.schedule_exceptions)
      ? couponSchedule.schedule_exceptions
      : [];

    // Exception dates are part of the restriction, not decoration: the backend
    // accepts an exceptions-only rule (every weekday closed, specific dates
    // open) and enforces it. Dates already in the past are dropped — printing
    // last year's blackout tells the customer nothing.
    const startOfToday = moment().startOf("day");
    const parsedDate = (exception) =>
      moment(exception.date, "DD-MM-YYYY", true);
    const isUpcoming = (exception) => {
      const parsed = parsedDate(exception);
      return parsed.isValid() && !parsed.isBefore(startOfToday);
    };

    const activeExceptions = _.sortBy(
      _.filter(
        exceptions,
        (exception: any) =>
          !!(exception && exception.date && exception.active) &&
          isUpcoming(exception)
      ),
      (exception: any) => parsedDate(exception).valueOf()
    );
    const closingExceptions = _.sortBy(
      _.filter(
        exceptions,
        (exception: any) =>
          !!(exception && exception.date) &&
          !exception.active &&
          isUpcoming(exception)
      ),
      (exception: any) => parsedDate(exception).valueOf()
    );
    const hasActiveDay = _.some(schedule, (day: any) => !!(day && day.active));

    if (!hasActiveDay && _.isEmpty(activeExceptions)) {
      return empty;
    }

    let days = _.filter(
      this.formatStoreSchedule(schedule),
      (day) => day && day.schedule !== "disabled"
    );

    const openEveryDay =
      days.length === 7 && _.every(days, (day) => !day.schedule);

    // Open all week: the only thing that can restrict this coupon is a closing
    // exception, so describe it negatively. With none, nothing is restricted
    // and there is nothing to say — that is the panel's default shape.
    if (openEveryDay && _.isEmpty(activeExceptions)) {
      if (_.isEmpty(closingExceptions)) {
        return empty;
      }

      return {
        text: _.map(_.take(closingExceptions, 3), (exception: any) =>
          parsedDate(exception).format("DD/MM/YYYY")
        ).join(", "),
        blackout: true,
      };
    }

    // An exception that closes today overrides the weekly schedule for today, so
    // today must not be listed as valid — this label is only rendered when the
    // coupon is already being refused.
    const todayDate = moment().format("DD-MM-YYYY");
    const closedByExceptionToday = _.some(
      exceptions,
      (exception: any) =>
        !!exception && exception.date === todayDate && !exception.active
    );

    if (closedByExceptionToday) {
      const weekDayKeys = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];
      const todayLabel = this.translateService.instant(
        `store-schedule.${weekDayKeys[moment().day()]}`
      );
      days = _.reject(days, (day) => day.day === todayLabel);
    }

    const parts = _.map(days, (day) =>
      day.schedule ? `${day.day} ${day.schedule}` : day.day
    );

    _.each(_.take(activeExceptions, 3), (exception: any) => {
      const formattedDate = parsedDate(exception).format("DD/MM/YYYY");
      parts.push(
        exception.all_day || _.isEmpty(exception.time_periods)
          ? formattedDate
          : `${formattedDate} ${_.map(
              exception.time_periods,
              (timePeriod: any) =>
                `${this.toHHMMSS(timePeriod.start)} - ${this.toHHMMSS(
                  timePeriod.stop
                )}`
            ).join(", ")}`
      );
    });

    return { text: parts.join(", "), blackout: false };
  }

  formatStoreSchedule(schedule) {
    var weekDays = [
      this.translateService.instant("store-schedule.sunday"),
      this.translateService.instant("store-schedule.monday"),
      this.translateService.instant("store-schedule.tuesday"),
      this.translateService.instant("store-schedule.wednesday"),
      this.translateService.instant("store-schedule.thursday"),
      this.translateService.instant("store-schedule.friday"),
      this.translateService.instant("store-schedule.saturday"),
    ];

    var singleScheduleArray = [];

    _.each(schedule, (scheduleDay, key, list) => {
      if (scheduleDay.active && !scheduleDay.all_day) {
        var commentSchedule = "";
        scheduleDay.time_periods.forEach((tp, i) => {
          if (i > 0) {
            commentSchedule += ", ";
          }
          commentSchedule +=
            this.toHHMMSS(tp.start) + " - " + this.toHHMMSS(tp.stop);
        });

        singleScheduleArray.push({
          day: weekDays[key],
          schedule: commentSchedule,
        });
      } else if (scheduleDay.active && scheduleDay.all_day) {
        singleScheduleArray.push({
          day: weekDays[key],
          schedule: null,
        });
      } else {
        singleScheduleArray.push({
          day: weekDays[key],
          schedule: "disabled",
        });
      }
    });

    var sunday = _.head(singleScheduleArray);
    singleScheduleArray = _.takeRight(singleScheduleArray, 6);
    singleScheduleArray.push(sunday);
    return singleScheduleArray;
  }

  toHHMMSS(val) {
    // console.log("val", val);
    if (val) {
      let sec_num = parseInt(val, 10); // don't forget the second param
      let hours = Math.floor(sec_num / 3600);
      let minutes = Math.floor((sec_num - hours * 3600) / 60);
      let newhours = hours.toString();
      let newmins = minutes.toString();
      if (hours < 10) {
        newhours = "0" + hours;
      }
      if (minutes < 10) {
        newmins = "0" + minutes;
      }

      return newhours + ":" + newmins;
    } else {
      return "00:00";
    }
  }

  checkIfIsExceptionDay(couponsExceptionDays) {
    var weekDays = [
      this.translateService.instant("store-schedule.sunday"),
      this.translateService.instant("store-schedule.monday"),
      this.translateService.instant("store-schedule.tuesday"),
      this.translateService.instant("store-schedule.wednesday"),
      this.translateService.instant("store-schedule.thursday"),
      this.translateService.instant("store-schedule.friday"),
      this.translateService.instant("store-schedule.saturday"),
    ];
    this.todayIsCouponsExceptionDay = null;
    console.log("exception days called", couponsExceptionDays);
    if (!_.isEmpty(couponsExceptionDays)) {
      _.each(couponsExceptionDays, (day) => {
        if (isMoment(day.date)) {
          day.date.set("hour", 0);
          day.date.set("minutes", 0);
          day.date.set("seconds", 0);
          day.date.set("milliseconds", 0);
          let now = moment();
          now.set("hour", 0);
          now.set("minutes", 0);
          now.set("seconds", 0);
          now.set("milliseconds", 0);
          if (moment(day.date).isSame(now)) {
            this.todayIsCouponsExceptionDay = weekDays[moment().weekday()];
            this.showCouponsSheduleButton = true;
            console.log(
              "today is excpetion day",
              this.todayIsCouponsExceptionDay
            );
          }
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.couponsScheduleInfoModal) {
      this.couponsScheduleInfoModal.dismiss();
      this.couponsScheduleInfoModal = null;
    }

    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    this.subscriptions = [];
  }
}
